import { render, staticRenderFns } from "./Fullpage.vue?vue&type=template&id=4c4cc0d6&scoped=true"
import script from "./Fullpage.vue?vue&type=script&lang=js"
export * from "./Fullpage.vue?vue&type=script&lang=js"
import style0 from "./Fullpage.vue?vue&type=style&index=0&id=4c4cc0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cc0d6",
  null
  
)

export default component.exports